namespace SPA
{
	export namespace BRW
	{
		export namespace data
		{

			export class BRWTableDataModel
				extends ui.table.model.AbstractTableModel<Wollmilch.MP01.IObject>
			{

				public constructor( descriptor?: ui.table.model.ITableModelDescriptor )
				{
					super( descriptor );

					this.ModelReader( new BRWTableDataReader() );
				}

				public buildHeader(): JQuery<HTMLElement>
				{
					return new ui.base.BaseHTMLElement( 'tr' )
						.append( new ui.base.BaseHTMLElement( 'th' ).append( app.getMessage( 'BRW.GENERAL.LABEL.Table.number' ) ) )
						.append( new ui.base.BaseHTMLElement( 'th' ).append( app.getMessage( 'BRW.GENERAL.LABEL.Table.object' ) ) )
						.append( new ui.base.BaseHTMLElement( 'th' ).append( app.getMessage( 'BRW.GENERAL.LABEL.Table.created_at' ) ) )
					.Root();
				}

			}

		}
	}
}
